module.exports = __webpack_public_path__ + "static/media/Certificado MACONLINE.057e7239.pdf";